import { defineStore } from "pinia";
import { ref } from "vue";
import { toSeverity, type InformationBanner } from "@/types/informationBanner";
import { ApiRoutes } from '@/api/ApiRoutes';
import axios from '@/stores/interceptor';

export const useInformationBannerStore = defineStore('informationBanner', () => {
    const banners = ref<Map<string, InformationBanner>>(new Map());
    let lastUpdate = ref<Date>();

    const fetchInformationBanners = async () => {
        if (lastUpdate.value === undefined) {
            // This should force the elapsed time to be over 5 minutes.
            lastUpdate.value = new Date(1970, 1, 1, 0, 0, 0, 0);
        }
        const elapsedMillis = Date.now() - lastUpdate.value.getTime();
        if (elapsedMillis > 300000) { // 300000 should be 5 minutes
            axios
                .get(ApiRoutes.InformationBanner.GetBanners)
                .then((response) => {
                    lastUpdate.value = new Date();
                    const responseData = response.data as InformationBanner[];
                    responseData.forEach((value: InformationBanner, idx: number) => {
                        if (!banners.value.has(value.id)) {
                            banners.value.set(value.id, {
                                id: value.id,
                                name: value.name,
                                bannerText: value.bannerText,
                                icon: value.icon.toLowerCase(),
                                severity: toSeverity(value.severity.toLowerCase())
                            });
                        }
                    });
                })
                .catch(() => {
                    console.log("Could not fetch banners");
                });
        }
    };
    const clearAllBanners = () => {
        banners.value = new Map<string, InformationBanner>()
    };

    return {
        banners,
        fetchInformationBanners,
        clearAllBanners
    };
});
